export const items = [
  "Wysyłaj |powiadomienia push| aby informować mieszkańców o najnowszych |atrakcjach i wydarzeniach.",
  "Zyskaj wgląd do opinii mieszkańców dzięki |ankietom i sondażom.",
  "Zamieszczaj harmonogram wywozu odpadów i rozkład jazdy a będzie on dostępny dla mieszkańca w jednym miejscu dzięki naszej |aplikacji mobilnej.",
  "Wszystkie te funkcjonalności i więcej, możesz wypróbować dzięki |bezpłatnemu okresowi próbnemu.",
];
